module.exports = __webpack_public_path__ + "img/cancel.c380bd42.svg";